import { useState } from 'react';

export default function Filter({ filterSearch }) {

    const [filterData, setFilterData] = useState({
        district: "",
        state: "",
        pin: "",
        name: "",
        subject: "",
        fees: "",
        courses: "",
        review: ""
    });

    const resetData = () => {
        setFilterData({
            district: "",
            state: "",
            pin: "",
            name: "",
            subject: "",
            fees: "",
            courses: "",
            review: ""
        })
    }

    const handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value.trim().toUpperCase();
        setFilterData(pre => ({ ...pre, [name]: value }));
    }

    return (
        <div>
            <button className="btn  btn-secondary mt-2" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                <i className='bx bx-filter'></i> Filter
            </button>
            <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="staticBackdropLabel"> <i className='bx bx-filter'></i> Filter</h5>
                            <i className='bi bi-x bx-sm' data-bs-dismiss="modal" aria-label="Close"></i>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">

                                <div className="row gy-2">
                                    <div className="col-sm-4">
                                        <input className="form-control form-control-sm" name="district"
                                            value={filterData.district} onChange={handleChange} placeholder="District" />
                                    </div>
                                    <div className="col-sm-4">
                                        <input className="form-control form-control-sm" name="state"
                                            value={filterData.state} onChange={handleChange} placeholder="State" />
                                    </div>
                                    <div className="col-sm-4">
                                        <input className="form-control form-control-sm" name="pin"
                                            value={filterData.pin} onChange={handleChange} placeholder="Pin" />
                                    </div>
                                    <div className="col-sm-4">
                                        <input className="form-control form-control-sm" name="name"
                                            value={filterData.name} onChange={handleChange} placeholder="Name" />
                                    </div>
                                    <div className="col-sm-4">
                                        <input className="form-control form-control-sm" name="subject"
                                            value={filterData.subject} onChange={handleChange} placeholder="Subject" />
                                    </div>
                                    <div className="col-sm-4">
                                        <input className="form-control form-control-sm" name="fees"
                                            value={filterData.fees} onChange={handleChange} placeholder="Fees below" />
                                    </div>
                                    <div className="col-sm-4">
                                        <input className="form-control form-control-sm" name="courses"
                                            value={filterData.courses} onChange={handleChange} placeholder="Courses" />
                                    </div>
                                    <div className="col-sm-4">
                                        <select className="form-select form-select-sm" name="review"
                                            value={filterData.review} onChange={handleChange}>
                                            <option value="">Review</option>
                                            <option value="5">5</option>
                                            <option vlaue="4">4</option>
                                            <option value="3">3</option>
                                            <option value="2">2</option>
                                            <option value="1">1</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-sm btn-secondary"
                                onClick={() => resetData()}>Reset</button>
                            <button type="button" className="btn btn-sm btn-primary" data-bs-dismiss="modal"
                                onClick={() => filterSearch(filterData)}>Apply</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
}